<template>
  <div class="row">
      <div class="input-group input-group-sm">
          <input
              id="new-property-name"
              type="text"
              class="form-control"
              v-model="propertyName"
              :placeholder="$t('orders.add_property')"
              autofocus
          />
          <button
              class="btn btn-success"
              type="button"
              :disabled="!propertyName"
              @click.stop="addProperty"
          >
              <i class="fa fa-plus"></i>
          </button>
      </div>
  </div>
</template>

<script>
import {userHelper} from '../mixins/UserMixin'
import {restApi} from '../mixins/RestApiMixin'

export default {
    name: 'OrderGeometryPropertySelector',
    mixins: [userHelper, restApi],
    props: {
        userRight: {
            type: Object,
            default: null
        },
        largeMode: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            propertyName: ""
        }
    },

    methods: {
        addProperty: function () {
            // this.userRightUpdate.info = this.info
            this.$emit('addProperty', this.propertyName)
            this.reset()
        },
        reset: function () {
            this.propertyName = ""
        }
    }
}
</script>
